module.exports = __webpack_public_path__ + "media/images/icon_mypage_menu_off-dae6b437f25c2b7d396a6079b80f3e10.png";